module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"button":{"add_sensor":"センサーを追加"}},"en":{"button":{"add_sensor":"Create a sensor"}}}')
  delete Component.options._Ctor
}
